const handleRef = <TElement>(
    forwardedRef: React.MutableRefObject<TElement | null> | ((instance: TElement | null) => void),
    setFocusableElementRef: (instance: TElement | null) => void,
    element: TElement | null
): void => {
    setFocusableElementRef(element);

    if (typeof forwardedRef === 'function') {
        forwardedRef(element);
    } else if (forwardedRef) {
        forwardedRef.current = element;
    }
};

export default handleRef;
